export default __webpack_public_path__ + "static/kb_2_10-cd440ad9b9c9e0125cd14cf42bf38c63.jpg";